import React, { useEffect, useState } from "react";
import {
    LoadingOutlined
} from "@ant-design/icons";

// Components
import {
    Table, Spin
} from "antd";

// custom component
import { getColumnSearchProps } from "./TableDropdownFilter";
import "./style/_customtable.scss";

// Helpers
export const sorterFunction = (soryBy, prev, next) => prev[soryBy]
    .toLowerCase()
    .localeCompare(next[soryBy].toLowerCase());

export const romanize = (num) => {
    const lookup = {
        M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1
    }; let roman = ""; let i;
    for (i in lookup) {
        while (num >= lookup[i]) {
            roman += i;
            num -= lookup[i];
        }
    }
    return roman;
};
const CustomTable = function ({
    dataSource,
    components,
    columns,
    loading = false,
    withFilterRow = false,
    rowSelection = {},
    numColProps = {}, noCheckbox = false, paginationProps = {},
    style = {},
    scroll = {},
    className = "",
    showHeader = true,
    pagination = true,
    noNum = false,
    bordered = false,
    paginationConfig = {},
    rowKey,
    expandable,
    tableProps = {},
    romanizeParent = false
}) {
    const [paginationObj, setPaginationObj] = useState({
        page: 1,
        rows: 10
    });

    useEffect(() => {
        const {
            pageNumber,
            itemsInPage
        } = paginationConfig;
        if (pageNumber && paginationConfig) {
            setPaginationObj({
                page: pageNumber,
                rows: itemsInPage
            });
        }
    }, [paginationConfig]);

    const [filterObj, setFilterObj] = useState({
        searchText: "",
        searchedColumn: ""
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setFilterObj({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex
        });
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setFilterObj({ searchText: "" });
    };

    const dropdownFilterObj = {
        filterObj, setFilterObj, handleSearch, handleReset
    };

    let customColumns = [];
    if (!noNum) {
        customColumns.push({
            title: <span style={{ width: "100%", textAlign: "center", display: "block" }}>#</span>,
            dataIndex: "#",
            key: "#",
            render: (value, row, index) => {
                if (withFilterRow && !index) return "";

                const idx = withFilterRow ? index : (index + 1);
                const itemNumber = (paginationObj.page - 1) * paginationObj.rows + idx;

                if (romanizeParent && row?.children) return romanize(itemNumber);
                return itemNumber;
            },
            width: 80,
            ...numColProps
        });
    }

    customColumns = [
        ...customColumns,
        ...columns.map((col) => {
            let newCol = { ...col };
            if (col.dropdownFilter) {
                delete newCol.dropdownFilter;
                newCol = {
                    ...newCol,
                    ...getColumnSearchProps({ colname: newCol.key, ...dropdownFilterObj })
                };
            }
            if (newCol.sortString) {
                delete newCol.sortString;
                newCol.sorter = sorterFunction.bind(null, newCol.key);
            }
            newCol.dataIndex = newCol.key;
            return newCol;
        })
    ];

    const getSelectionProps = () => (!noCheckbox ? {
        rowSelection: {
            type: "checkbox",
            ...rowSelection
        }
    } : {});

    const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

    return (
        <Table
            style={style}
            className={`custom-table ${className} ${pagination ? "" : "nopagination"}`}
            loading={{
                spinning: loading,
                indicator: <Spin
                    indicator={antIcon}
                    tip={(
                        <span style={{
                            marginTop: "15mm", marginLeft: "-3mm", display: "block"
                        }}
                        >
                            Loading...
                        </span>
                    )}
                />
            }}
            {
                ...getSelectionProps()
            }
            showHeader={showHeader}
            rowKey={rowKey}
            components={components}
            dataSource={dataSource}
            bordered={bordered}
            columns={customColumns}
            expandable={expandable}
            scroll={{
                y: 400,
                ...scroll
            }}
            pagination={pagination ? {
                current: paginationObj.page,
                pageSize: paginationObj.rows,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                onChange(page, rows) {
                    setPaginationObj({
                        page,
                        rows
                    });
                    if (paginationProps.onChangePagination) {
                        paginationProps.onChangePagination(
                            page,
                            rows
                        );
                    }
                },
                onShowSizeChange(page, rows) {
                    setPaginationObj({
                        page,
                        rows
                    });
                    if (paginationProps.onChangePagination) {
                        paginationProps.onChangePagination(
                            page,
                            rows
                        );
                    }
                },
                ...paginationProps
            } : pagination}
            {
                ...tableProps
            }
        />
    );
};

export default CustomTable;
